import script from "./ChatAttachedMessages.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatAttachedMessages.vue?vue&type=script&setup=true&lang=ts"

import "./ChatAttachedMessages.vue?vue&type=style&index=0&id=6a943e92&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a943e92"]])

export default __exports__